<script setup>
import { CheckCircleIcon } from '@heroicons/vue/24/solid'
import CTAButton from '@components/CTAButton.vue'
import Subtitle from '@components/Subtitle.vue'

// Marketing callout for the subscription (SUB-MVP-65/67). The price is NOT shown
// here — it lives on /subscription, served by the backend, so it is never
// hard-coded. Rendered only when the subscription_marketing flag is on, so it
// can ship dark and be switched on from Nova.
const benefits = [
  'Unlimited ABN & GST registrations, updates and cancellations',
  'A dedicated registered tax agent for your business',
  'Automatic quarterly reminders by email and SMS',
  'A free 30-minute consultation with your tax agent every 6 months',
]
</script>

<template>
  <div class="mx-auto max-w-7xl px-0 sm:px-6 lg:px-8" dusk="subscription-callout">
    <div class="mx-auto max-w-2xl lg:text-center">
      <Subtitle>
        📚 ABN Books: one membership for your whole business
      </Subtitle>
      <p class="mt-6 text-lg leading-8 text-gray-600">
        Stop paying per task. Become a member and get a dedicated tax agent plus
        everything your sole-trader business needs, all in one plan.
      </p>
    </div>

    <div class="mx-auto mt-12 max-w-2xl">
      <ul class="grid gap-4 sm:grid-cols-2">
        <li v-for="benefit in benefits" :key="benefit" class="flex items-start gap-3">
          <CheckCircleIcon class="mt-0.5 h-6 w-6 flex-none text-stone-600" aria-hidden="true" />
          <span class="text-base leading-7 text-gray-700">{{ benefit }}</span>
        </li>
      </ul>

      <div class="mt-10 flex justify-center">
        <CTAButton href="/membership" text="See the plans" size="xl" />
      </div>
    </div>
  </div>
</template>
